import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconSearch = (props: IconProps) => (
  <svg className={cn(iconStyles(props))} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 25">
    <g fill="none" fillRule="evenodd" strokeLinejoin="round" strokeWidth="1.8">
      <path
        strokeLinecap="round"
        d="M19 10.00062C19 14.970832 14.970556 19 10 19s-9-4.029167-9-8.99938C1 5.030404 5.029444 1 10 1s9 4.030405 9 9.00062z"
      />
      <path d="M17 16l2 2" />
      <path
        strokeLinecap="round"
        d="M24.42296 23.42296c-.769386.769387-2.017869.769387-2.786075 0l-3.059845-3.059845c-.769387-.768206-.769387-2.016689 0-2.786075.769386-.769387 2.016689-.769387 2.786075 0l3.059845 3.058665c.769387.770566.769387 2.017869 0 2.787255z"
      />
    </g>
  </svg>
);
